import React from 'react'
import Number from './Cards/Number'
import './style/Numbers.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import { faHandshake } from '@fortawesome/free-regular-svg-icons'


function Numbers() {
    return (
        <div className="numbers">
            <Number icon={<FontAwesomeIcon icon={faCheck}/>} number="123+" info="Project Compleate"/>
            <Number icon={<FontAwesomeIcon icon={faUserFriends}/>} number="70" info="Satisfied Client"/>
            <Number icon={<FontAwesomeIcon icon={faShieldAlt}/>} number="15" info="Active project"/>
            <Number icon={<FontAwesomeIcon icon={faHandshake}/>} number="35" info="Team Members"/>
        </div>
    )
}

export default Numbers
